import { AxiosError } from "axios";
import { useQuery } from "react-query";
import axiosClient from "../utils/axiosClient";

export type ScreenshotItem = {
  id: number;
  screenshotFileUrl: string;
  screenshotFileName: string;
  executionId: number;
};

export type ScreenshotResponse = {
  screenshots: ScreenshotItem[];
  screenshotStartTimeMs: number;
  filePrefix: string;
  screenshotIntervalSecs: number;
};

export const useExecutionScreenshots = (id: string) => {
  return useQuery<any, AxiosError<any>, ScreenshotResponse>(
    ["screenshots", id],
    () =>
      axiosClient
        .get<ScreenshotResponse>(`/execution/getOne/${id}/screenshots`)
        .then(({ data }) => data),
    {
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );
};
